import React, { useContext } from 'react'

import { LAYER_CONTROL_WIDTH, LAYER_HEIGHT_WITH_BORDER } from 'constant'

import { TranslationContext } from 'contexts/TranslationContext'
import { TimelineLeftOffsetContext } from 'contexts/TimelineLeftOffsetContext'
import styles from './newLayer.module.scss'

type Props = {
  layerIndex: number,
  scrollTop: number
}

function NewLayer({ layerIndex, scrollTop }: Props) {
  const { t } = useContext(TranslationContext)
  const { timelineLeftOffset } = useContext(TimelineLeftOffsetContext)

  return (
    <div
      className={styles.item}
      style={{
        transform: `translateY(${layerIndex * LAYER_HEIGHT_WITH_BORDER - scrollTop}px)`,
        left: `${timelineLeftOffset - LAYER_CONTROL_WIDTH}px`,
      }}
    >
      <div className={styles.itemBtn}>{t('TIMELINE_TEXT_ADD_LAYER')}</div>
    </div>

  )
}

export default NewLayer
